import { Icon } from "@/components"
import { useStyles } from "@/components/PageHeader/PageHeader.styles"
import { useBreakpoint } from "@/hooks/useBreakpoint"
import { ActionIcon, Flex, Title, useMantineTheme } from "@mantine/core"
import React from "react"
import { useNavigate } from "react-router-dom"
interface HeaderProps {
    title: string | React.ReactNode
    rightSection?: React.ReactNode
    hideBackButton?: boolean
    goBackLink?: string
    /* Whether the header should be fixed at the top right below the navbar */
    relative?: boolean
    extraClass?: string
    noMarginOnButtons?: boolean
}

export const PageHeader = ({
    title,
    rightSection,
    hideBackButton = false,
    goBackLink,
    relative,
    extraClass = "",
    noMarginOnButtons = false,
}: HeaderProps) => {
    const { classes } = useStyles({ relative, noMarginOnButtons })
    const theme = useMantineTheme()
    const isLargerThanXS = useBreakpoint(theme.fn.largerThan("xs"))
    const navigate = useNavigate()

    return (
        <Flex className={`${classes.wrapper} ${extraClass}`}>
            <Flex className={classes.leftSection}>
                {!hideBackButton && (
                    <ActionIcon
                        variant="transparent"
                        aria-label="Return to previous page"
                        onClick={() => (goBackLink ? navigate(goBackLink) : navigate(-1))}
                        className={classes.backButton}
                        data-plum-id="page-header-back-button"
                    >
                        <Icon icon="arrow-left" iconFamily="far" size="1x" />
                    </ActionIcon>
                )}
                <Title className={classes.title} order={1} size={isLargerThanXS ? "h1" : "1.25rem"} id="form-title">
                    {title}
                </Title>
            </Flex>
            {rightSection && <div className={classes.rightSectionWrapper}>{rightSection}</div>}
        </Flex>
    )
}
